import * as O from "fp-ts/Option"
import { pipe } from "fp-ts/function"

/** Adresse http(s) avec un hôte. */
function isWebUrl(url: URL): boolean {
  const isWeb = url.protocol === "http:" || url.protocol === "https:"
  return isWeb && url.hostname !== ""
}

/**
 * Lien gardé s'il est une adresse web http(s) avec hôte.
 * Jamais un `javascript:` ni un `data:` rendu cliquable.
 * Même règle que le serveur (`LINK_NOT_HTTP`).
 *
 * @example
 * webLink(" https://exemple.fr/c.pdf ") // O.some("https://exemple.fr/c.pdf")
 * webLink("javascript:alert(1)") // O.none
 */
export function webLink(raw: string | null): O.Option<string> {
  return pipe(
    O.fromNullable(raw),
    O.map((value) => value.trim()),
    O.filter((value) => value !== ""),
    O.filter((value) => URL.canParse(value) && isWebUrl(new URL(value))),
  )
}
